'use client';

import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import { ToolSettingsRadioGroup } from '../../_components/ToolSettingsRadioGroup';

interface CharacterCreationSettingsProps {
  sampleCount: number;
  onSampleCountChange: (value: number) => void;
}

const SAMPLE_COUNT_OPTIONS = ['1', '2', '3', '4'].map((value) => ({
  value,
  label: value,
}));

export const CharacterCreationSettings: FC<CharacterCreationSettingsProps> = ({ sampleCount, onSampleCountChange }) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col gap-2">
      <span className="font-medium light:text-system-black text-sm text-system-white leading-[1.4]">
        {t('create.createForm.settings.amount.title')}
      </span>
      <ToolSettingsRadioGroup
        value={sampleCount.toString()}
        options={SAMPLE_COUNT_OPTIONS}
        onValueChange={(nextValue) => onSampleCountChange(Number.parseInt(nextValue, 10))}
        className="h-12 rounded-10 border border-system-white08 light:border-system-black08 bg-system-white04 light:bg-system-black04"
        optionsWrapperClassName="h-full rounded-10 hover:bg-system-white08 light:hover:bg-system-black08"
        activeOptionClassName="rounded-10 border-[#6673FF] bg-[rgba(87,101,242,0.24)] light:bg-[rgba(87,101,242,0.16)]"
        labelClassName="light:text-system-black text-system-white"
        renderContent={(option) => (
          <span className="font-medium light:text-system-black text-sm text-system-white leading-[1.4]">
            {option.label}
          </span>
        )}
      />
    </div>
  );
};
